import { SessionArticleEvent, SessionEvent } from '../ISessionEvent';
import { UserArticleProgressState } from '../../Types/UserArticle';

export class ArticleProgressChangeEvent extends SessionArticleEvent {
  constructor(articleId: string, state: UserArticleProgressState) {
    super('article-progress-change', articleId, {
      state,
    });
  }
}
